import React from "react";

const PintGlass = props => (
  <svg viewBox="0 0 215 215" {...props}>
    <path
      d="M55.4 24.9l16 161.1h69.8l16.5-161.1H55.4zm8.1 21.2L62 30.5h89.1L149.5 46l-86 .1z"
      fill="#ffffff"
    />
  </svg>
);

export default PintGlass;